// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-wrapper[data-v-b17c96f2]{display:flex;justify-content:flex-end}.button-wrapper .v-btn[data-v-b17c96f2]:first-of-type{margin-right:1rem}@media screen and (max-width:600px){.button-wrapper[data-v-b17c96f2]{flex-direction:column-reverse}.button-wrapper .v-btn[data-v-b17c96f2]:first-of-type{margin-right:0;margin-top:1rem}.fa-sign-out-alt[data-v-b17c96f2]{display:none}}", ""]);
// Exports
module.exports = exports;
